import { type } from "../../types/types";

export default function reducer(state = { pageState: { id: 1 } }, action) {
  switch (action.type) {
    case type.SET_PAGE_STATE:
      return { ...state, ...action.pageState };
    default:
      return state;
  }
}
